
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/toaster';
import { ThemeProvider } from 'next-themes';
import { SentryErrorBoundary } from '@/components/SentryErrorBoundary';
import Index from '@/pages/Index';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import Explore from '@/pages/Explore';
import Search from '@/pages/Search';
import SolutionDetail from '@/pages/SolutionDetail';
import SolutionPreview from '@/pages/SolutionPreview';
import AdminTools from '@/pages/AdminTools';
import NotFound from '@/pages/NotFound';
import './App.css';

const queryClient = new QueryClient();

function App() {
  return (
    <SentryErrorBoundary>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <QueryClientProvider client={queryClient}>
          <Router>
            <div className="min-h-screen bg-background">
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/explore" element={<Explore />} />
                <Route path="/search" element={<Search />} />
                <Route path="/solution/:slug" element={<SolutionDetail />} />
                <Route path="/solution/preview/:tempId" element={<SolutionPreview />} />
                <Route path="/admin" element={<AdminTools />} />
                <Route path="/admin/tools" element={<AdminTools />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            <Toaster />
          </Router>
        </QueryClientProvider>
      </ThemeProvider>
    </SentryErrorBoundary>
  );
}

export default App;
